import {
  useState, useCallback, useMemo, useEffect, useRef,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import userApi from '@api/userApi';
import usersActions from '@state/user/actions';
import getColumnsAdmin from './columnsDevicesAdmin';

function useUsuarios() {

  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const abortController = useRef(null);

  const [loading, setLoading] = useState(true);
  const [sorter, setSorter] = useState(true);
  const [isSorter, setIsSorter] = useState(false);
  const [users, setUsers] = useState([]);

  const [isCreate, setIsCreate] = useState(false);
  const [valueFilter, setValueFilter] = useState('');
  const [modalData, setModalData] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleResetPassword, setIsModalVisibleResetPassword] = useState(false);
  const [loadingResetPassword, setLoadingResetPassword] = useState(false);

  const currentUser = useSelector(({ user }) => user);

  const limit = 1000;
  const skip = 0;

  const getAllusers = useMemo(() => () => {

    setLoading(true);
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    userApi.getAllUsers({ signal, skip, limit })
      .then((response) => {

        setUsers(response);
        setLoading(false);

})
      .catch((resError) => {

        // eslint-disable-next-line
        console.log(resError);
        setLoading(false);

});

  }, [setUsers]);

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
    // eslint-disable-next-line
    setIsCreate(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

}, []);

  const viewUsuario = (e) => {

    setModalData(e);
    setIsModalVisible(true);

};

  const deleteUsuario = useCallback((e) => { // Delete device by Id

    abortController.current = new AbortController();
    const { signal } = abortController.current;
    const { id } = e;

    userApi.deleteUserById({ signal, id })
      .then((response) => {

        message.success(t('forms.users.feedbacks.delete_success'));
        getAllusers();

      })
      .catch((error) => {

        message.error(t('forms.users.feedbacks.delete_failed'));

      });

  }, [getAllusers, t]);

  const editUsuario = useCallback((e) => { // edit device, save data device in redux

    const {
      id, email,
      first_name,
      last_name,
      phone,
      role,
    } = e;

    let defaultData;

    if (role !== 'Visitor') {

      defaultData = {
        email,
        first_name,
        last_name,
        phone,
        role,
        birthdate: e.birthdate ? moment(e.birthdate, 'YYYY-MM-DD') : '',
        business_id: e?.business_types?.map((item) => item.id) || [],
        devices_id: e?.devices_id?.map((item) => item.id) || [],
        clients_id: e?.clients_id?.map((item) => item.id) || [],
      };

} else {

      defaultData = {
        email,
        first_name,
        last_name,
        phone,
        role,
        // eslint-disable-next-line
        birthdate: e.birthdate ? moment(e.birthdate, 'YYYY-MM-DD') : null,
        business_id: [],
        // eslint-disable-next-line
        business_id_visitor: Array.isArray(e?.business_types) && e.business_types.length > 0 ? e.business_types[0].id : '',
        devices_id: Array.isArray(e?.devices_id) && e.devices_id.length > 0 ? e.devices_id[0].id : '',
        clients_id: Array.isArray(e?.clients_id) && e.clients_id.length > 0 ? e.clients_id[0].id : '',
      };

}

    dispatch(usersActions.setIdUserEdit({ id }));
    dispatch(usersActions.setCreateEditUser(defaultData));
    history.push('/usuarios/editar-usuario');

  }, [dispatch, history]);

  useEffect(() => { // componentDidMount

    getAllusers();
    getPermissonCreate();

  }, [history, getAllusers]);

  const createUser = useCallback( // Go to create /crear-dispositivo
    () => {

      history.push('/usuarios/crear-usuario');

    },
    [history],
  );

  const columns = useMemo(
    // eslint-disable-next-line
    () => getColumnsAdmin(t, currentUser, deleteUsuario, editUsuario, viewUsuario), [t, currentUser, deleteUsuario, editUsuario, viewUsuario],
  );

  const arrayFilterAux = [];
  users.forEach((value, index) => { // remove current user

    arrayFilterAux.push(value);

});

  const changeSort = () => {

    setIsSorter(true);
    if (sorter) {

      setUsers([...users].sort((a, b) => a.email.localeCompare(b.email)));

} else {

      setUsers([...users].sort((a, b) => b.email.localeCompare(a.email)));

}
    setSorter(!sorter);

};

const resetPassword = () => {

  setLoadingResetPassword(true);
  userApi
    .resetPassword(modalData?.email)
    .then((response) => {

      setLoadingResetPassword(false);
      setIsModalVisible(false);
      message.success(t('forms.recovery_password.feedbacks.success_recovery'));

    })
    .catch((resError) => {

      setLoadingResetPassword(false);
      const { statusText } = resError;
      message.error(statusText);

    });

};

const onUserResetPassword = (values) => {

  console.log('onUserResetPassword', values);

};

const arrayFilter = arrayFilterAux.filter((user) => (
  user && (
    user.email.toUpperCase().includes(valueFilter.toUpperCase())
    || (user.first_name && user.first_name.toUpperCase().includes(valueFilter.toUpperCase()))
  )
));

  return {
    loading,
    sorter,
    isSorter,
    changeSort,
    columns,
    users,
    arrayFilter,
    arrayFilterAux,
    isModalVisible,
    resetPassword,
    loadingResetPassword,
    isModalVisibleResetPassword,
    setIsModalVisibleResetPassword,
    onUserResetPassword,
    setIsModalVisible,
    modalData,
    createUser,
    setValueFilter,
    isCreate,
  };

}

export default useUsuarios;
